import { render, staticRenderFns } from "./left-item.vue?vue&type=template&id=2b6b9ec2&scoped=true&"
import script from "./left-item.vue?vue&type=script&lang=js&"
export * from "./left-item.vue?vue&type=script&lang=js&"
import style0 from "./left-item.vue?vue&type=style&index=0&id=2b6b9ec2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6b9ec2",
  null
  
)

export default component.exports